import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { useChosenSalesman } from "@/store/useChosenSalesman";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesmanWrapper',
  setup(__props) {

const chosenSalesman = useChosenSalesman();
const onSearch = (ev) => {
  const formData = new FormData(ev.target);
  const formProps = Object.fromEntries(formData);
  const val = formProps["zipcode"] as string;
  chosenSalesman.update(val);
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    salesman: _unref(chosenSalesman),
    onSearch: onSearch
  })
}
}

})